import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "lib-base";
import {Observable} from "rxjs";
import {ITipoPersona} from "../shared/interfaces/configuracion";

@Injectable({
  providedIn: 'root'
})
export class TipoPersonaService {

  private baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipo-persona`;
  }

  getAll(): Observable<ITipoPersona[]> {
    return this.http.get<ITipoPersona[]>(`${this.baseUrl}/public`);
  }

  getAllOrdinales(): Observable<ITipoPersona[]> {
    return this.http.get<ITipoPersona[]>(`${this.baseUrl}/public/ordinales`);
  }
}
